import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { GpuMasterI } from 'src/app/core/models/nodeGpu';
import { NodeService } from 'src/app/core/services/node.service';
import { ManageGpuInstancesComponent } from '../../modals/manage-gpu-instances/manage-gpu-instances.component';

enum GpuMessageI {
  Loading = "Loading GPU's...",
  Empty = "No GPU's yet.",
  Error = "Failed to load GPU's."
}

@Component({
  selector: 'app-node-gpu',
  templateUrl: './node-gpu.component.html',
  styleUrls: ['./node-gpu.component.scss']
})
export class NodeGpuComponent implements OnInit {

  gpuList: GpuMasterI[] = [];
  depName: string;
  activeNodeName: string;
  masterListSub$ = new BehaviorSubject<string>("");
  noGPUMessage = GpuMessageI.Loading;

  constructor(
    private dialog: MatDialog,
    private _nodeService: NodeService
  ) { }

  ngOnInit(): void {
    this.getMasterList();
  }

  ngOnDestroy(){
    this.masterListSub$.next(null);
    this.masterListSub$.complete();
  }

  getMasterList(){
    this._nodeService
    .getGpuMasterListForNode(this.depName, this.activeNodeName)
    .pipe(takeUntil(this.masterListSub$))
    .subscribe({
      next: (data: any) => {
        if(!data || data?.length == 0){
          this.noGPUMessage = GpuMessageI.Empty;
        }
        this.gpuList = JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        this.noGPUMessage = GpuMessageI.Error;
      }
    })
  }

  manageGpu(gpu: GpuMasterI){
    this.dialog.open(ManageGpuInstancesComponent, {
      disableClose: true,
      width: "40%",
      height: "70%",
      maxHeight: "100%",
      data: {
        gpuId: gpu.id,
        frameBufferInGB: gpu.frameBufferInGB,
        depName: this.depName,
        nodeName: this.activeNodeName
      }
    }).afterClosed().subscribe(x => {
      if(x) this.getMasterList();
    });
  }
}
